module.exports = __webpack_public_path__ + "static/media/slash-eye-blue.dcf3c7cb.svg";